import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { alpha, Box, useTheme } from '@mui/material';
import React from 'react';

import { useUploadModal } from '../../UploadModalContext';

interface IProps {
  hasErrors: boolean;
}

const StatusCell: React.FC<IProps> = ({ hasErrors }) => {
  const theme = useTheme();
  const { profile } = useUploadModal();
  const statusWidth = profile.columnWidths.status;

  return (
    <Box
      sx={{
        width: statusWidth,
        height: 36,
        minWidth: statusWidth,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: hasErrors ? alpha(theme.palette.error.light, 0.1) : alpha(theme.palette.success.light, 0.1),
      }}
    >
      {hasErrors ? (
        <ErrorOutlineIcon color="error" fontSize="small" />
      ) : (
        <CheckCircleOutlineIcon color="success" fontSize="small" />
      )}
    </Box>
  );
};

export default React.memo(StatusCell);
